import { g } from '@hcie/core';
import { EventBus } from '@hcie/shared';

function getElements() {
    const container = document.getElementById('canvasScrollArea') as HTMLElement | null;
    const wrapper = document.getElementById('canvasWrapper') as HTMLElement | null;
    const canvas = document.getElementById('drawingCanvas') as HTMLCanvasElement | null;
    return { container, wrapper, canvas };
}

function applyCssZoom(zoom: number) {
    const { wrapper, canvas } = getElements();
    if (!wrapper || !canvas) return;

    // Update dimensions
    wrapper.style.width = `${Math.round(g.image_width * zoom)}px`;
    wrapper.style.height = `${Math.round(g.image_height * zoom)}px`;
    canvas.style.width = `${Math.round(g.image_width * zoom)}px`;
    canvas.style.height = `${Math.round(g.image_height * zoom)}px`;

    // Apply rotation transformation (#2074-Gestures)
    const rotation = (g as any).canvasRotation || 0;
    wrapper.style.transform = `rotate(${rotation}deg)`;
    wrapper.style.transformOrigin = 'center center';
}

function clampZoom(z: number) {
    return Math.max(0.05, Math.min(z, 32));
}

export function applyZoom(oldZoom: number, e: MouseEvent | null) {
    const { container } = getElements();
    const newZoom = clampZoom(g.zoom || 1);

    if (!container) {
        applyCssZoom(newZoom);
        EventBus.emit('RENDER_LAYERS');
        window.dispatchEvent(new Event('zoomChanged'));
        return;
    }

    // Bug 51: Precise focus point on zoom (Fine-tuned)
    const { wrapper } = getElements();
    const rect = container.getBoundingClientRect();
    if (!wrapper) return;

    // 1. Snapshot cursor vs scroll offset
    const clientX = e ? e.clientX : rect.left + rect.width / 2;
    const clientY = e ? e.clientY : rect.top + rect.height / 2;

    const scrollLeft = container.scrollLeft;
    const scrollTop = container.scrollTop;

    // 2. Map coordinates relative to document content (accounting for wrapper centering/scaling)
    // Formula: [ (CursorOnScreen - ScreenStart) + CurrentScroll - ContentRelativeOffset ] / OldZoom
    const focalX = (clientX - rect.left + scrollLeft - wrapper.offsetLeft) / oldZoom;
    const focalY = (clientY - rect.top + scrollTop - wrapper.offsetTop) / oldZoom;

    // 3. Scale CSS dimensions
    applyCssZoom(newZoom);

    // 4. Force browser-synced scroll repositioning to avoid jitter/jumping
    requestAnimationFrame(() => {
        // Recalculate target scroll to keep the focal pixel at the exact same screen location
        container.scrollLeft = (focalX * newZoom) - (clientX - rect.left) + wrapper.offsetLeft;
        container.scrollTop = (focalY * newZoom) - (clientY - rect.top) + wrapper.offsetTop;
        
        EventBus.emit('RENDER_LAYERS');
        window.dispatchEvent(new Event('zoomChanged'));
    });
}

export function zoomIn(e: MouseEvent | null) {
    const oldZoom = g.zoom || 1;
    g.zoom = clampZoom(oldZoom * 1.1);
    applyZoom(oldZoom, e);
}

export function zoomOut(e: MouseEvent | null) {
    const oldZoom = g.zoom || 1;
    g.zoom = clampZoom(oldZoom / 1.1);
    applyZoom(oldZoom, e);
}

